import React, { Component } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Link,
  Divider,
  Zoom,
  Button,
  CardMedia,
  Tabs,
  Tab,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { VideoLibrary, InsertLink } from "@material-ui/icons";
import "date-fns";
import "fontsource-roboto";
import SearchNoResult from "./search-noResult";
import { formateDate } from "../utils/utilTools";
import Pagination from "@material-ui/lab/Pagination";

require("../assets/css/style.css");
require("../assets/css/all-style.css");

const useStyles = {
  root: {
    "& > *": {
      width: "65ch",
    },
  },
  inputText: {
    padding: "0 5px 0 0",
  },
  breakLine: {
    margin: "20px 0 0 0",
  },
  breakLineInset: {
    margin: "20px 0 0 16px",
  },
};

const themeObj = {
  theme_1: ["公积金"],
  theme_2: ["医疗"],
  theme_3: ["婚姻"],
  theme_4: ["入学", "教育", "科研"],
  theme_5: ["企业开办"],
};

const AntTabs = withStyles({
  root: {
    marginBottom: "10px",
  },
  indicator: {
    backgroundColor: "#1890ff",
  },
})(Tabs);

const AntTab = withStyles((theme) => ({
  root: {
    fontSize: "16px",
    textTransform: "none",
    height: 30,
    minWidth: 72,
    fontWeight: theme.typography.fontWeightBold,
    marginRight: theme.spacing(4),
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:hover": {
      color: "#40a9ff",
      opacity: 1,
    },
    "&$selected": {
      color: "#1890ff",
      fontWeight: theme.typography.fontWeightBold,
    },
    "&:focus": {
      color: "#40a9ff",
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);

class SearchAll extends Component {
  constructor() {
    super();
    this.state = {
      selectedDate: new Date(),
      checked: false,
      tabValue: 0,
      resultTagSpanWidthList: [],
      fileResultTagSpanWidthList: [],
      themeTabValue: 0,
    };
  }

  componentWillUnmount = () => {
    this.setState = () => {
      return;
    };
  };

  componentWillReceiveProps(prop) {
    this.setState({
      checked: prop.results && prop.results.length > 0,
    });
  }

  render() {
    const _state = this.state;
    const {
      setHotInfo,
      pageNum,
      handlePaging,
      handleTabsChange,
      pages,
      results,
      fwJuhe,
      juheResult1,
      juheResult2,
      showLoading,
      isGh,
      nojc,
      originalKeyword,
      correctedKeyword,
    } = this.props;

    const loading = <div className="loader"> </div>;

    let keyword = nojc ? originalKeyword : correctedKeyword;
    let themeImgName = "";
    Object.keys(themeObj).forEach((themeKey) => {
      if (themeObj[themeKey].includes(decodeURI(keyword)) || themeObj[themeKey].some(theme => decodeURI(keyword).includes(theme))) {
        themeImgName = themeKey;
      }
    });

    let aggName0 = "办事服务";
    let tabValue0 = 4;
    let juheResult0Contents =
      fwJuhe && fwJuhe.length > 0
        ? fwJuhe.slice(0, 5).map((value, index) => (
            <Typography
              variant="body2"
              className="search-result-aggregation-wrapper"
            >
              <Typography variant="body1" component="body2">
                <Link
                  variant="body1"
                  className="search-result-aggregation-title"
                  style={{ maxWidth: 580 }}
                  title={value.title}
                  href={value.url}
                  target="_blank"
                  dangerouslySetInnerHTML={{
                    __html: value.titleN ? value.titleN : value.title,
                  }}
                ></Link>
              </Typography>
              <Typography component="p">
                <Button
                  className="search-result-aggregation-btn"
                  color="default"
                  variant="outlined"
                  size="small"
                  onClick={() => {
                    window.open(value.url);
                  }}
                >
                  去办事
                </Button>
                <div>
                  <span className="search-result-aggregation-showtime">
                    {formateDate(value.showtime)}
                  </span>
                </div>
              </Typography>
              <Divider />
            </Typography>
          ))
        : "";

    let aggName1 = "新闻动态";
    let tabValue1 = 1;
    let juheResult1Contents =
      juheResult1 && juheResult1.length > 0
        ? juheResult1.slice(0, 5).map((value, index) => (
            <Typography
              variant="body2"
              className="search-result-aggregation-wrapper"
            >
              <Typography variant="body1" component="body2">
                <Link
                  variant="body1"
                  className="search-result-aggregation-title"
                  style={tabValue1 === 4 ? { maxWidth: 580 } : {}}
                  title={value.title}
                  href={value.url}
                  target="_blank"
                  dangerouslySetInnerHTML={{
                    __html: value.titleN ? value.titleN : value.title,
                  }}
                ></Link>
              </Typography>
              <Typography component="p">
                {tabValue1 === 4 ? (
                  <Button
                    className="search-result-aggregation-btn"
                    color="default"
                    variant="outlined"
                    size="small"
                    onClick={() => {
                      window.open(value.url);
                    }}
                  >
                    去办事
                  </Button>
                ) : (
                  ""
                )}
                <div>
                  {tabValue1 === 2 ? (
                    <span
                      dangerouslySetInnerHTML={{
                        __html: value.laiyuan ? value.laiyuan : value.source,
                      }}
                      style={{
                        marginRight: "8px",
                        color: "#666",
                        fontSize: isGh ? "20px" : "13px",
                      }}
                    ></span>
                  ) : (
                    ""
                  )}
                  <span className="search-result-aggregation-showtime">
                    {formateDate(value.showtime)}
                  </span>
                </div>
              </Typography>
              <Divider />
            </Typography>
          ))
        : "";

    let aggName2 = "政民互动";
    let tabValue2 = 3;
    let juheResult2Contents =
      juheResult2 && juheResult2.length > 0
        ? juheResult2.slice(0, 5).map((value, index) => (
            <Typography
              variant="body2"
              className="search-result-aggregation-wrapper"
            >
              <Typography variant="body1" component="body2">
                <Link
                  variant="body1"
                  className="search-result-aggregation-title"
                  style={tabValue2 === 4 ? { maxWidth: 580 } : {}}
                  title={value.title}
                  href={value.url}
                  target="_blank"
                  dangerouslySetInnerHTML={{
                    __html: value.titleN ? value.titleN : value.title,
                  }}
                ></Link>
              </Typography>
              <Typography component="p">
                {tabValue2 === 4 ? (
                  <Button
                    className="search-result-aggregation-btn"
                    color="default"
                    variant="outlined"
                    size="small"
                    onClick={() => {
                      window.open(value.url);
                    }}
                  >
                    去办事
                  </Button>
                ) : (
                  ""
                )}
                <div>
                  <span className="search-result-aggregation-showtime">
                    {formateDate(value.showtime)}
                  </span>
                  {tabValue2 === 2 ? (
                    <span
                      dangerouslySetInnerHTML={{
                        __html: value.laiyuan
                          ? "发布机构：" + value.laiyuan
                          : "发布机构：" + value.source,
                      }}
                      style={{
                        color: "#666",
                        fontSize: isGh ? "20px" : "13px",
                      }}
                    ></span>
                  ) : (
                    ""
                  )}
                </div>
              </Typography>
              <Divider />
            </Typography>
          ))
        : "";

    let tempAggName = "";
    let tempTabValue = 0;
    let tempJuheResultContents = "";
    let antTabJuhe0 = JSON.parse(JSON.stringify(fwJuhe));
    let antTabJuhe1 = JSON.parse(JSON.stringify(juheResult1));
    let antTabJuhe2 = JSON.parse(JSON.stringify(juheResult2));
    let tempAntTabJuhe = [];
    const fwScoreMax = fwJuhe && fwJuhe.length > 0 ? fwJuhe[0].score : 0;
    const xwScoreMax = juheResult1 && juheResult1.length > 0 ? juheResult1[0].score : 0;
    const hdScoreMax = juheResult2 && juheResult2.length > 0 ? juheResult2[0].score : 0;
    if(xwScoreMax === Math.max(fwScoreMax, xwScoreMax, hdScoreMax)) {
      tempAggName = aggName0;
      tempTabValue = tabValue0;
      tempJuheResultContents = juheResult0Contents;
      aggName0 = aggName1;
      tabValue0 = tabValue1;
      juheResult0Contents = juheResult1Contents;
      aggName1 = tempAggName;
      tabValue1 = tempTabValue;
      juheResult1Contents = tempJuheResultContents;

      tempAntTabJuhe = JSON.parse(JSON.stringify(antTabJuhe1));
      antTabJuhe1 = JSON.parse(JSON.stringify(antTabJuhe0))
      antTabJuhe0 = JSON.parse(JSON.stringify(tempAntTabJuhe));
    } else if (hdScoreMax === Math.max(fwScoreMax, xwScoreMax, hdScoreMax)) {
      tempAggName = aggName0;
      tempTabValue = tabValue0;
      tempJuheResultContents = juheResult0Contents;
      aggName0 = aggName2;
      tabValue0 = tabValue2;
      juheResult0Contents = juheResult2Contents;
      aggName2 = tempAggName;
      tabValue2 = tempTabValue;
      juheResult2Contents = tempJuheResultContents;

      tempAntTabJuhe = JSON.parse(JSON.stringify(antTabJuhe2));
      antTabJuhe2 = JSON.parse(JSON.stringify(antTabJuhe0))
      antTabJuhe0 = JSON.parse(JSON.stringify(tempAntTabJuhe));
    }

    let resultContents =
      results && results.length > 0 ? (
        results.map((value, index) => (
          <Zoom
            in={_state.checked}
            style={{ transformOrigin: "0 0 0" }}
            {...(_state.checked > 0 ? { timeout: index * 500 } : {})}
          >
            <Card className="news-content-card" key={index}>
              <CardContent className="news-content-card-class">
                <button
                  class="draw"
                  onClick={() => {
                    window.open(value.url);
                    setHotInfo(value.url, value.title);
                  }}
                >
                  {value.catalogname ? (
                    <span className="tag">{value.catalogname}</span>
                  ) : (
                    ""
                  )}
                  <Typography variant="h5" component="h2">
                    <Link
                      className="search-result-title"
                      title={value.title}
                      href={value.url}
                      target="_blank"
                      variant="body2"
                      dangerouslySetInnerHTML={{
                        __html: value.titleN ? value.titleN : value.title,
                      }}
                    ></Link>
                    &emsp;
                    {!value.catalogname ? (
                      ""
                    ) : value.catalogname.indexOf("视频") >= 0 ? (
                      <div className="title-icon">
                        <VideoLibrary style={{ color: "#f0b755" }} />
                      </div>
                    ) : value.catalogname.indexOf("国务院") >= 0 ||
                      value.catalogname.indexOf("江苏") >= 0 ? (
                      <div className="title-icon">
                        <InsertLink style={{ color: "#f0b755" }} />
                      </div>
                    ) : (
                      ""
                    )}
                  </Typography>
                  <Typography component="p">
                    <div className="abstract-heigth-class">
                      <span
                        dangerouslySetInnerHTML={{
                          __html: value.json ? value.json : value.title,
                        }}
                      ></span>
                    </div>
                    <div>
                      <span className="date-class">
                        发布时间：{formateDate(value.showtime)}
                      </span>
                    </div>
                  </Typography>
                </button>
              </CardContent>
              <Divider />
            </Card>
          </Zoom>
        ))
      ) : (
        <div className="content-class" style={{ textAlign: "center" }}>
          <SearchNoResult />
        </div>
      );

    const handleChange = (event, newValue) => {
      this.setState({
        themeTabValue: newValue,
      });
    };

    return (
      <Grid container spacing={1}>
        {showLoading ? (
          loading
        ) : (
          <div className="all-list-tab">
            {themeImgName && pageNum === 1 ? (
              <Card elevation={4} className="search-all-card">
                <CardMedia
                  style={{ height: 58 }}
                  image={require("../assets/images/" + themeImgName + ".jpg")}
                />
                <CardContent style={{ paddingTop: 0 }}>
                  <AntTabs
                    value={this.state.themeTabValue}
                    onChange={handleChange}
                  >
                    <AntTab label={aggName0} />
                    <AntTab label={aggName1} />
                    <AntTab label={aggName2} />
                  </AntTabs>
                  {_state.themeTabValue === 0
                    ? antTabJuhe0.slice(0, 8).map((result) => {
                        return (
                          <Typography
                            style={{
                              height: 30,
                              lineHeight: "30px",
                              display: "flex",
                            }}
                          >
                            •
                            <Link
                              href={result.url}
                              style={{
                                paddingLeft: 10,
                                color: "#3a83e9",
                                maxWidth: 600,
                                display: "inline-block",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                              }}
                              target="_blank"
                              title={result.title}
                            >
                              {result.title}
                              {result.ssjg ? "[" + result.ssjg + "]" : ""}
                            </Link>
                          </Typography>
                        );
                      })
                    : _state.themeTabValue === 1
                    ? antTabJuhe1.slice(0, 8).map((result) => {
                        return (
                          <Typography
                            style={{
                              height: 30,
                              lineHeight: "30px",
                              display: "flex",
                            }}
                          >
                            •
                            <Link
                              href={result.url}
                              style={{
                                paddingLeft: 10,
                                color: "#3a83e9",
                                maxWidth: 600,
                                display: "inline-block",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                              }}
                              target="_blank"
                              title={result.title}
                            >
                              {result.title}
                            </Link>
                          </Typography>
                        );
                      })
                    : antTabJuhe2.slice(0, 8).map((result) => {
                        return (
                          <Typography
                            style={{
                              height: 30,
                              lineHeight: "30px",
                              display: "flex",
                            }}
                          >
                            •
                            <Link
                              href={result.url}
                              style={{
                                paddingLeft: 10,
                                color: "#3a83e9",
                                maxWidth: 600,
                                display: "inline-block",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                              }}
                              target="_blank"
                              title={result.title}
                            >
                              {result.title}
                            </Link>
                          </Typography>
                        );
                      })}
                </CardContent>
              </Card>
            ) : (
              ""
            )}
            {!themeImgName && pageNum === 1 && juheResult0Contents && juheResult0Contents.length > 0 ? (
              <Card elevation={4} className="search-all-card">
                <CardContent>
                  <Grid item xs={12}>
                    <Typography>
                      <Link
                        className="search-result-aggregation"
                        component="button"
                        variant="body1"
                        dangerouslySetInnerHTML={{
                          __html: aggName0,
                        }}
                      ></Link>
                      <Link
                        className="search-result-aggregation"
                        component="button"
                        onClick={() => handleTabsChange(this, tabValue0)}
                        variant="body1"
                        dangerouslySetInnerHTML={{
                          __html: "查看更多 >",
                        }}
                      ></Link>
                    </Typography>
                    <Divider />
                    {juheResult0Contents}
                  </Grid>
                </CardContent>
              </Card>
            ) : (
              ""
            )}
            {!themeImgName && pageNum === 1 && juheResult1Contents && juheResult1Contents.length > 0 ? (
              <Card elevation={4} className="search-all-card">
                <CardContent>
                  <Grid item xs={12}>
                    <Typography>
                      <Link
                        className="search-result-aggregation"
                        component="button"
                        variant="body1"
                        dangerouslySetInnerHTML={{
                          __html: aggName1,
                        }}
                      ></Link>
                      <Link
                        className="search-result-aggregation"
                        component="button"
                        onClick={() => handleTabsChange(this, tabValue1)}
                        variant="body1"
                        dangerouslySetInnerHTML={{
                          __html: "查看更多 >",
                        }}
                      ></Link>
                    </Typography>
                    <Divider />
                    {juheResult1Contents}
                  </Grid>
                </CardContent>
              </Card>
            ) : (
              ""
            )}
            {!themeImgName && pageNum === 1 && juheResult2Contents && juheResult2Contents.length > 0 ? (
              <Card elevation={4} className="search-all-card">
                <CardContent>
                  <Grid item xs={12}>
                    <Typography>
                      <Link
                        className="search-result-aggregation"
                        component="button"
                        variant="body1"
                        dangerouslySetInnerHTML={{
                          __html: aggName2,
                        }}
                      ></Link>
                      <Link
                        className="search-result-aggregation"
                        component="button"
                        onClick={() => handleTabsChange(this, tabValue2)}
                        variant="body1"
                        dangerouslySetInnerHTML={{
                          __html: "查看更多 >",
                        }}
                      ></Link>
                      <Divider />
                    </Typography>
                    {juheResult2Contents}
                  </Grid>
                </CardContent>
              </Card>
            ) : (
              ""
            )}
            <Card elevation={0} className="search-result-card">
              <Grid item xs={12}>
                {resultContents}
              </Grid>
              <Pagination
                className="page-class"
                size="medium"
                shape="rounded"
                count={pages}
                page={pageNum}
                onChange={handlePaging}
              />
            </Card>
          </div>
        )}
      </Grid>
    );
  }
}

export default withStyles(useStyles)(SearchAll);
